import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { WitnessInterviewService } from '../../../../shared/services/witnessInterview.service';

@Component({
  selector: 'review-witness-interview',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-witness-interview.component.html',
  styleUrl: './review-witness-interview.component.css'
})
export class ReviewWitnessInterviewComponent implements OnInit {
  
  @Input() caseId: string | null = null;
  
  yesNo = EYesNo;
  witnessInterview: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "Witness Information",
      children: [
        {
          type: 'string',
          questionText: "Witness Interviewed:",
          answer: "witness_interviewed"
        },
        {
          type: 'date',
          questionText: "Date of Interview:",
          answer: "date_interview"
        },
        {
          type: 'string',
          questionText: "Time of Interview:",
          answer: "time_interview"
        },
        {
          type: 'string',
          questionText: "Person Conducting Interview:",
          answer: "person_conducting_interview"
        }
      ]
    },
    {
      sectionName: "Involvement",
      children: [
        {
          type: 'number',
          questionText: "Did you witness the threat or situation?",
          answer: "witness_threat"
        },
        {
          type: 'number',
          questionText: "Were you the recipient or target of the threat?",
          answer: "threat_target"
        }
      ]
    },
    {
      sectionName: "Description",
      children: [
        {
          type: 'string',
          questionText: "Describe exactly what happened including details such as time, place, or other people present.",
          answer: "incident_details"
        },
        {
          type: 'string',
          questionText: "What exactly did the student who made or posed the threat say and/or do? Please be specific.",
          answer: "student_actions"
        }
      ]
    },
    {
      sectionName: "Impressions",
      children: [
        {
          type: 'number',
          questionText: "Do you know this student?",
          answer: "know_student"
        },
        {
          type: 'string',
          questionText: "If yes, please explain: ",
          answer: "know_student_information"
        },
        {
          type: 'number',
          questionText: "Are you concerned that he or she might actually follow through and harm someone?",
          answer: "harm_concern"
        },
        {
          type: 'string',
          questionText: "If yes, please explain: ",
          answer: "harm_concern_information"
        },
        {
          type: 'number',
          questionText: "Are you aware of any history or situations that may have influenced this situation?",
          answer: "history_influence"
        },
        {
          type: 'string',
          questionText: "If yes, please explain: ",
          answer: "history_influence_information"
        },
        {
          type: 'string',
          questionText: "What do you think he or she meant when saying/doing that?",
          answer: "student_meaning"
        },
        {
          type: 'string',
          questionText: "How do you feel about what he or she said/did?",
          answer: "student_feelings"
        },
        {
          type: 'string',
          questionText: "Why, in your opinion, did he or she say that?",
          answer: "opinion"
        },
      ]
    },
    {
      sectionName: "Summary",
      children: [
        {
          type: 'number',
          questionText: "Is there other information regarding this student you have not yet shared that you believe would be important for the threat assessment team to consider?",
          answer: "other"
        },
        {
          type: 'string',
          questionText: "If yes, please explain:",
          answer: "other_information"
        },
        {
          type: 'string',
          questionText: "Is there anyone else who might know something about this student in relation to this situation? (List all names)",
          answer: "student_relation"
        }
      ]
    }
  ];

  constructor(
    private witnessInterviewService: WitnessInterviewService
  ) { }

  ngOnInit(): void {
    this.loadFullTeamThreatAssessment();
  }

  loadFullTeamThreatAssessment(): void {
    if (this.caseId) {
      this.loading = true;      
      this.witnessInterviewService.getWitnessInterviewByCaseId(this.caseId).subscribe({
        next: (response) => {
          this.witnessInterview = response;
          this.loading = false;
        },
        error: (error) => {
          console.error('Error fetching witness interview:', error);
          this.loading = false;
        }
      });
    }
  }

  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }
}
